import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Progress } from "../components/ui/progress";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { PlusCircle, Edit2, Trash2, Zap } from 'lucide-react';

const GoalTracker = () => {
  const [goals, setGoals] = useState([
    { id: 1, name: "Reduce Carbon Emissions", progress: 65, target: 100, unit: "tons CO2e" },
    { id: 2, name: "Increase Renewable Energy Usage", progress: 40, target: 75, unit: "%" },
    { id: 3, name: "Improve Diversity in Workforce", progress: 75, target: 100, unit: "%" },
    { id: 4, name: "Enhance Supply Chain Sustainability", progress: 30, target: 100, unit: "%" },
  ]);

  const [newGoal, setNewGoal] = useState({ name: '', target: '', unit: '' });
  const [isAdding, setIsAdding] = useState(false);

  const addGoal = () => {
    if (newGoal.name && newGoal.target && newGoal.unit) {
      setGoals([...goals, { ...newGoal, id: Date.now(), progress: 0 }]);
      setNewGoal({ name: '', target: '', unit: '' });
      setIsAdding(false);
    }
  };

  const editGoal = (id) => {
    // Implement edit goal functionality
    console.log("Editing goal", id);
  };

  const deleteGoal = (id) => {
    setGoals(goals.filter(goal => goal.id !== id));
  };

  const overallProgress = goals.reduce((sum, goal) => sum + (goal.progress / goal.target), 0) / goals.length * 100;

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">ESG Goal Tracker</h1>
        <Button onClick={() => setIsAdding(true)}><PlusCircle className="mr-2 h-4 w-4" /> Add Goal</Button>
      </div>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>Overall Progress</CardTitle>
        </CardHeader>
        <CardContent>
          <Progress value={overallProgress} className="w-full mb-2" />
          <p className="text-center font-bold">{Math.round(overallProgress)}% Complete</p>
        </CardContent>
      </Card>

      {isAdding && (
        <Card className="mb-6">
          <CardHeader>
            <CardTitle>Add New Goal</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <Input
                placeholder="Goal Name"
                value={newGoal.name}
                onChange={(e) => setNewGoal({...newGoal, name: e.target.value})}
              />
              <Input
                type="number"
                placeholder="Target"
                value={newGoal.target}
                onChange={(e) => setNewGoal({...newGoal, target: e.target.value})}
              />
              <Input
                placeholder="Unit"
                value={newGoal.unit}
                onChange={(e) => setNewGoal({...newGoal, unit: e.target.value})}
              />
              <Button onClick={addGoal}>Add Goal</Button>
            </div>
          </CardContent>
        </Card>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {goals.map((goal) => (
          <Card key={goal.id}>
            <CardHeader>
              <CardTitle className="flex justify-between items-center">
                {goal.name}
                <div>
                  <Button variant="ghost" size="sm" onClick={() => editGoal(goal.id)}><Edit2 className="h-4 w-4" /></Button>
                  <Button variant="ghost" size="sm" onClick={() => deleteGoal(goal.id)}><Trash2 className="h-4 w-4" /></Button>
                </div>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <Progress value={(goal.progress / goal.target) * 100} className="w-full" />
              <div className="flex justify-between mt-2">
                <p>{goal.progress} / {goal.target} {goal.unit}</p>
                <p className="font-bold">{Math.round((goal.progress / goal.target) * 100)}% Complete</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="mt-6">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Zap className="mr-2 h-5 w-5 text-yellow-500" />
            AI-Generated Suggestions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="list-disc pl-5 space-y-2">
            <li>Consider setting a more ambitious target for renewable energy usage to align with industry leaders.</li>
            <li>Your diversity improvement goal is progressing well. Consider expanding this goal to include specific metrics for different diversity dimensions.</li>
            <li>The supply chain sustainability goal seems to be lagging. Identify key suppliers to engage with for improvement opportunities.</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};

export default GoalTracker;